import { render, staticRenderFns } from "./Dashboards.vue?vue&type=template&id=4939f2ce&scoped=true&"
import script from "./Dashboards.vue?vue&type=script&lang=js&"
export * from "./Dashboards.vue?vue&type=script&lang=js&"
import style0 from "./Dashboards.vue?vue&type=style&index=0&id=4939f2ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4939f2ce",
  null
  
)

export default component.exports